var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0671 21.7421L15.9552 17.9992C15.5248 17.951 15.0921 17.9255 14.659 17.9229C11.1988 17.9224 4.2915 19.6285 4.2915 23.0149V25.5633H15.9552L12.0671 21.7421ZM14.659 15.3761C15.6842 15.3761 16.6864 15.0774 17.5389 14.5178C18.3913 13.9582 19.0558 13.1629 19.4481 12.2323C19.8404 11.3018 19.9431 10.2779 19.7431 9.28999C19.5431 8.30212 19.0494 7.39471 18.3244 6.6825C17.5994 5.97029 16.6758 5.48527 15.6703 5.28877C14.6647 5.09227 13.6224 5.19312 12.6752 5.57857C11.728 5.96401 10.9184 6.61674 10.3488 7.45421C9.77925 8.29168 9.47523 9.27628 9.47523 10.2835C9.47502 10.9523 9.60896 11.6146 9.8694 12.2326C10.1298 12.8505 10.5117 13.412 10.993 13.8849C11.4744 14.3579 12.046 14.733 12.675 14.9888C13.304 15.2447 13.9782 15.3763 14.659 15.3761Z",
    fill: "#707070"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4519 26.1983L15.9548 21.7422L17.7692 19.9469L20.4519 22.5953L27.0998 16.0132L28.9141 17.8085L20.4519 26.1983Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignUp);
export default __webpack_public_path__ + "static/media/signUp.278cdd1f3743ccdf70ee9522a1565c8f.svg";
export { ForwardRef as ReactComponent };